export default __webpack_public_path__ + "static/media/fridges.7b356ca3.png";